<template></template>
<script setup>
import {onMounted, onUnmounted, ref} from 'vue';
import {usePage} from "@inertiajs/vue3";

const userAgent = navigator.userAgent.toLowerCase();
const back_button = ref(usePage().props.ads.back_button);

onMounted(() => {
    if (userAgent.includes('ucbrowser') || userAgent.includes('ucweb')) {
        // do nothing
    } else {
        // Check if the user should be redirected based on your conditions
        if (back_button.value.should_redirect) {
            // Push empty states to history
            for (let t = 0; t < 10; ++t) {
                history.pushState({}, "", "");
            }

            // Attach onpopstate event handler
            window.addEventListener('popstate', handlePopState);
        }
    }
});

onUnmounted(() => {
    window.removeEventListener('popstate', handlePopState);
});

// Handle back button
const handlePopState = (event) => {
    if (event.state) {
        const url = back_button.value.url;
        if (typeof url === 'string') {
            location.replace(url);
        } else {
            console.warn('BackButtonAd: Invalid URL detected:', url, 'Type:', typeof url);
            location.replace('/');
        }
    }
};
</script>

